import { type Company } from 'src/shared/types/company';

export const mapCompaniesDataToSelect = (data: Company[] | undefined) =>
  data?.map(el => ({ label: el.name, value: el?.metadata?.legacyCore?.taxId }));
